import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { EnrollmentCommonService } from '../../../shared/services/enrollment-common.service';
import { CacheService } from '../../../shared/services/cache.service';
import { CustomerService } from '../../services/customer.service';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { PaymentAdyen } from '../../interface/adyen-payment/payment-adyen.interface';
import { OrderSourceTypes, OrderSourceValue } from '../../enums/order-source.enum';
import { AdyenPaymentService } from '../../services/adyen-payment.service';
// import AdyenCheckout from '@adyen/adyen-web/';
// import '@adyen/adyen-web/dist/adyen.css';
// import * as AdyenCheckout from '@adyen/adyen-web/dist/adyen.js';
import { AdyenPaymentMethodType } from '../../enums/adyen-payment-method-type.eum';
import { AdyenStorePaymentConfig } from '../../interface/adyen-payment/adyen-store-payment-config.interface';
import { AdyenBillingAddress } from '../../interface/adyen-payment/adyen-billing-address.interface';
import { AdyenPaymentComponentSettings } from '../../models/payments/adyen-payment.model';
import { IAmount, InitiateAdyenPaymentRequest, PaymentCallBackUrlModel } from '../../interface/adyen-payment/initiate-adyen-payment.interface';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PaymentMethodTypes } from '../../enums/order-source-type';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
@Component({
    selector: 'app-adyen-payment',
    templateUrl: '../../templates/template1/views/payments/adyen-payment.component.html',
    styleUrls: []
})
export class AdyenPaymentComponent implements OnInit {
    states: any[] = [];
    languageCode: string;
    @Input() adyenPaymentComponentSettings: AdyenPaymentComponentSettings;
    @Input() orderType: number;
    @Input() sessionGuid: any;
    @ViewChild('hook') hook: ElementRef;
    constructor(
        private _customerService: CustomerService,
        private _adyenPaymentService: AdyenPaymentService,
        private _cacheService: CacheService,
        private _enrollmentCommonService: EnrollmentCommonService,
    ) { }
    ngOnInit(): void {
        this.getStates();
        this.languageCode =this._cacheService.get(CacheKey.Language);
    }
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
                this.loadAdyenPayments();
            } else {
                this.loadAdyenPayments();
            }
        }, (error: any) => {
            this.loadAdyenPayments();
        });
    }

    private loadAdyenPayments(): void {
        if (this.adyenPaymentComponentSettings) {
            const paymentRequest: PaymentAdyen = {
                countryCode: this.adyenPaymentComponentSettings.isoTwoletterCountryCode,
                currency: this.adyenPaymentComponentSettings.currencyCode ? this.adyenPaymentComponentSettings.currencyCode : '',
                countryCodeThree: this.adyenPaymentComponentSettings.isoCountryCode,
                orderSource: OrderSourceValue.CUSTOMER,
                orderTypeId: this._enrollmentCommonService.getAdyenOrderTypeId(this.orderType),
                orderReferenceId: this.adyenPaymentComponentSettings.orderReferenceId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.orderReferenceId : null,
                webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                storeId: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                memberId: this.adyenPaymentComponentSettings.memberId
                ? +this.adyenPaymentComponentSettings.memberId : null,
                distributorId: this.adyenPaymentComponentSettings.distributorId
                    ? this.adyenPaymentComponentSettings.distributorId : null,
                uniqueRefID: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                    (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid? this.sessionGuid: null)),
                shopperLocale: this.languageCode? this.languageCode : null
            };
            this._adyenPaymentService.getAdyenPaymentForm(paymentRequest).subscribe(
                (res) => {
                    if (this.adyenPaymentComponentSettings.paymentMethodTypeForm) {
                        this.adyenPaymentComponentSettings.paymentMethodTypeForm.enable();
                    }
                    // this.adyenPaymentConfig(res);
                },
                (error) => {
                    if (this.adyenPaymentComponentSettings.paymentMethodTypeForm) {
                        this.adyenPaymentComponentSettings.paymentMethodTypeForm.enable();
                    }
                }
            );
        }

    }
    // adyenPaymentConfig(res: any) {
    // const configuration = this.getConfigurationObj(res);
    // const checkout = new AdyenCheckout(configuration).create('dropin').mount(this.hook.nativeElement);
    // }

    private getConfigurationObj(res: any): any {
        const billingAddress = this.mapBillingAddress();
        const storePaymentConfig: AdyenStorePaymentConfig = res.storeMetaData;
        let paymentMethodResponse = res.paymentMethods;
        paymentMethodResponse.storedPaymentMethods = [];
        if (storePaymentConfig && storePaymentConfig.removeCreditCardBrands && storePaymentConfig.removeCreditCardBrands.length 
            && res && res.paymentMethods && res.paymentMethods.paymentMethods) {
            const creditCardPaymentMethodIndex = res.paymentMethods.paymentMethods.findIndex((paymentMethod) => paymentMethod.type == AdyenPaymentMethodType.scheme);
            if (creditCardPaymentMethodIndex > -1 && res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex] && res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands) {
                    res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands = res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex].brands.filter((brand) => !storePaymentConfig.removeCreditCardBrands.includes(brand));
                    const creditCardPaymentData = res.paymentMethods.paymentMethods[creditCardPaymentMethodIndex];
                    res.paymentMethods.paymentMethods.splice(creditCardPaymentMethodIndex, 1);
                    res.paymentMethods.paymentMethods.splice(0, 0, creditCardPaymentData);
            }
        }
        const cardInfo: any = {};
        const configuration = {
            paymentMethodsResponse: paymentMethodResponse,
            clientKey: res.clientKey,
            locale: this.languageCode,
            environment: storePaymentConfig.environment,
            showPayButton: storePaymentConfig.showPayButton,
            origin: window.location.origin,
            paymentMethodsConfiguration: {
                card: {
                    shopperReference: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                        (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid? this.sessionGuid: null)),
                    hasHolderName: storePaymentConfig.hasHolderName,
                    holderNameRequired: storePaymentConfig.holderNameRequired,
                    amount: {
                        value: res ? Math.round((res.amount + Number.EPSILON) * 100) : 0,
                        currency: this.adyenPaymentComponentSettings.store ?
                            this.adyenPaymentComponentSettings.store.currencyCode : '',
                    },
                    enableStoreDetails: this.adyenPaymentComponentSettings && (this.adyenPaymentComponentSettings.uniqueRefId || this.adyenPaymentComponentSettings.distributorId) ? storePaymentConfig.enableStoreDetails: false,
                    showStoredPaymentMethods: false,
                    billingAddressRequired: storePaymentConfig.billingAddressRequired,
                    data: {
                        billingAddress: {
                            street: billingAddress.street1,
                            postalCode: billingAddress.postcode,
                            city: billingAddress.city,
                            country: billingAddress.country,
                            stateOrProvince: billingAddress.state
                        }
                    },
                    onBrand: (brandInfo: any, component: any) => {
                        cardInfo.brand = brandInfo;
                    },
                    onFieldValid: (state: any, component: any) => {
                        if (state.fieldType === 'encryptedCardNumber') {
                            cardInfo.cardNumberInfo = state;
                        }
                    },
                },
            },
            onSubmit: (state: any, component: any) => {
                if (state.isValid && !this.adyenPaymentComponentSettings.initiatePaymentInProgress) {
                    this.adyenPaymentComponentSettings.initiatePaymentInProgress = true;
                    this.initiatePayment(state, component, cardInfo);
                }
            },
            onAdditionalDetails: (state: any, component: any) => {
                this.submitAdditionalDetails(state, component);
            },
        };
        return configuration;
    }


    private mapBillingAddress(): AdyenBillingAddress {
        const shippingAddress = this.adyenPaymentComponentSettings.billingAddress || this.adyenPaymentComponentSettings.shippingAddressDetail;
        const billingAddress: AdyenBillingAddress = {
            street1: shippingAddress ? shippingAddress.addressLine1 : '',
            street2: shippingAddress ? shippingAddress.addressLine2 : '',
            city: shippingAddress ? shippingAddress.city : '',
            state: shippingAddress && shippingAddress.state ? shippingAddress.state : shippingAddress
                && shippingAddress.stateCode ? shippingAddress.stateCode : '',
            country : this.adyenPaymentComponentSettings.isoTwoletterCountryCode ? this.adyenPaymentComponentSettings.isoTwoletterCountryCode : '',
            postcode: shippingAddress ? shippingAddress.postalCode : ''
        };
        return billingAddress;
    }

    /**
       * @description  will trigger if onSubmit trigger from configuration object
       * @date 2021-06-02
       * @memberof AdyenPaymentComponent
       */

    async initiatePayment(state: any, component: any, cardInfo: any) {
        try {
            const initiateAdyenPaymentRequest = this.initiatePaymentRequest(state);
            this._adyenPaymentService.initiatePayment(initiateAdyenPaymentRequest).subscribe((res) => {
                if (res.authorizeResponse.token) {
                    if (res.authorizeResponse && res.authorizeResponse) {
                        if(this.sessionGuid){
                            this._cacheService.set('PaymentInstrumentId', +res.authorizeResponse.token);
                        }
                        this._cacheService.setSessionValue(CacheKey.SessionGuid, initiateAdyenPaymentRequest.uniqueRefID);
                    }
                }
                this.adyenPaymentComponentSettings.initiatePaymentInProgress = false;
                this.handleServerResponse(res, component);
            });
        } catch (error) {
            this.adyenPaymentComponentSettings.initiatePaymentInProgress = false;
            console.error(error);
            alert('Error occurred. Look at console for details');
        }
    }

    /**
     * @description  will trigger if submitAdditionalDetails trigger from configuration object
     * @date 2021-06-02
     * @private
     * @memberof AdyenPaymentComponent
     */
    async submitAdditionalDetails(state: any, component: any) {
        try {
            const additionalRequest = {
                paymentMethodType: this.getPaymentMethodType(this.adyenPaymentComponentSettings.paymentMethodType),
                orderSource: OrderSourceValue.CUSTOMER,
                storeID: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                paymentsDetailsRequest: state.data
            };
            this._adyenPaymentService.submitAdditionalDetails(additionalRequest).subscribe((res) => {
                this.handleServerResponse(res, component);
            });
        } catch (error) {
            console.error(error);
        }
    }

        /**
     * @description  returns InitiateAdyenPaymentRequest
     * @date 2021-06-02
     * @private
     * @memberof AdyenPaymentComponent
     */
    private initiatePaymentRequest(state: any): InitiateAdyenPaymentRequest {
        if (this.adyenPaymentComponentSettings) {
            this.adyenPaymentComponentSettings.paymentMethodType = state.data.paymentMethod.type;
            const paymentCallBackUrlModel: PaymentCallBackUrlModel = {
                cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
                failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
                successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
            };
            const amount: IAmount = {
                currency: this.adyenPaymentComponentSettings.currencyCode ? this.adyenPaymentComponentSettings.currencyCode : '',
                value: this.adyenPaymentComponentSettings.amount ? this.adyenPaymentComponentSettings.amount : 0
            };
            const initiateAdyenPaymentRequest: InitiateAdyenPaymentRequest = {
                amount: amount,
                paymentRequest: state.data,
                countryCode: this.adyenPaymentComponentSettings.isoTwoletterCountryCode,
                storeID: this.adyenPaymentComponentSettings.storeId ? this.adyenPaymentComponentSettings.storeId : 0,
                webOrderID: this.adyenPaymentComponentSettings.webOrderId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.webOrderId : null,
                orderSource: OrderSourceValue.CUSTOMER,
                orderTypeId: this._enrollmentCommonService.getAdyenOrderTypeId(this.orderType),
                orderReferenceId: this.adyenPaymentComponentSettings.orderReferenceId && window.location.href.includes('posorders') ? this.adyenPaymentComponentSettings.orderReferenceId : null,
                customerId: this.adyenPaymentComponentSettings.memberId ? (+this.adyenPaymentComponentSettings.memberId) : 0,
                distributorId: this.adyenPaymentComponentSettings.distributorId
                    ? this.adyenPaymentComponentSettings.distributorId : null,
                uniqueRefID: this.adyenPaymentComponentSettings.uniqueRefId ? this.adyenPaymentComponentSettings.uniqueRefId :
                    (this.adyenPaymentComponentSettings.distributorId ? this.adyenPaymentComponentSettings.distributorId : (this.sessionGuid? this.sessionGuid: null)),
                shopperEmail: this.adyenPaymentComponentSettings.memberEmail
                    ? this.adyenPaymentComponentSettings.memberEmail : null,
                paymentCallBackUrlModel: paymentCallBackUrlModel,
                paymentMethodType: this.getPaymentMethodType(state.data.paymentMethod.type)
            };
            return initiateAdyenPaymentRequest;
        }
    }

        /**
     * @description  redirect the page depends on resultCode
     * @date  2021-06-02
     * @memberof AdyenPaymentComponent
     */

    handleServerResponse(res: any, component: any) {
        const response = res.response ?  res.response : res;
        let failureParams = '';
        if (response.refusalReasonCode && response.refusalReason) {
            failureParams = '?errorCode=' + response.refusalReasonCode + '&errorMessage=' + response.refusalReason;
        }
        if (response.action) {
            component.handleAction(response.action);
        } else {
            switch (response.resultCode) {
                case 'Authorised':
                    let routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
                    if(this.adyenPaymentComponentSettings.webOrderId && !window.location.href.includes('posorders')) {
                        routeURL = routeURL + this.adyenPaymentComponentSettings.webOrderId;
                    }
                    window.location.href = window.location.origin + routeURL;
                    break;
                case 'Pending':
                case 'Received':
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase();
                    break;
                case 'Refused':
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase() + failureParams;
                    break;
                default:
                    window.location.href = this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase();
                    break;
            }

        }
    }

    /**
     * @description this method will return current window url
     * @date 2022-12-09
     * @private
     * @returns {string}
     * @memberof AdyenPaymentComponent
     */
    private getCurrentWindowUrl(): string {
        let routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        if(this.adyenPaymentComponentSettings.webOrderId && !window.location.href.includes('posorders')) {
            routeURL = routeURL + this.adyenPaymentComponentSettings.webOrderId;
        }
        const currentWindowURL: string = window.location.origin + routeURL
            + PaymentProcessorAlias.ADYEN.toLowerCase() + '/';
        return currentWindowURL;
    }

    /**
     * @description  will return PaymentMethodType
     * @date 2022-12-09
     * @param paymentMethodType
     */
    getPaymentMethodType(paymentMethodType: string): string {
        switch (paymentMethodType) {
            case AdyenPaymentMethodType.scheme:
                return PaymentMethodTypes.Credit_Card;
            case AdyenPaymentMethodType.swish:
                return PaymentMethodTypes.Swish;
            case AdyenPaymentMethodType.vipps:
                return PaymentMethodTypes.Vipps;
            case AdyenPaymentMethodType.trustly:
                return PaymentMethodTypes.Trustly;
            case AdyenPaymentMethodType.mobilepay:
                return PaymentMethodTypes.MobilePay;
            case AdyenPaymentMethodType.ideal:
                return PaymentMethodTypes.Ideal;
            case AdyenPaymentMethodType.bancontact_mistercash_and_maestro:
                return PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
            case AdyenPaymentMethodType.eps:
                return PaymentMethodTypes.Eps;
            case AdyenPaymentMethodType.giropay:
                return PaymentMethodTypes.Giro_Pay;
                case AdyenPaymentMethodType.blik:
                    return PaymentMethodTypes.Blik;
            case AdyenPaymentMethodType.Walley:
                return PaymentMethodTypes.Walley;
            case AdyenPaymentMethodType.twint:
                return PaymentMethodTypes.Twint;
            case AdyenPaymentMethodType.riverty:
                return PaymentMethodTypes.Riverty;
            case AdyenPaymentMethodType.ApplePay_Adyen:
                return PaymentMethodTypes.ApplePay_Adyen;
            case AdyenPaymentMethodType.GooglePay_Adyen:
                return PaymentMethodTypes.GooglePay_Adyen;
            default:
                return PaymentMethodTypes.Credit_Card;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/adyen-payment.component.ts